import { BaseNomenclatorModel} from './base.model';

export class CoccidiostatsModel extends BaseNomenclatorModel{
    id: number;
    uid: string;
    name: string;
    security_sentence: string;
}
